import { Link } from "react-router-dom";
import { Flower2, MapPin, Clock, Phone } from "lucide-react";
import { BRAND, WA_DISPLAY, waLink, AREAS } from "../../data";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative bg-[#2c1e16] text-[#faf7f2] overflow-hidden grain"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2 mb-5">
            <Flower2 className="h-6 w-6 text-[#b8862f]" strokeWidth={1.5} />
            <span className="font-display text-2xl">{BRAND}</span>
          </div>
          <p className="text-[#e5d9c5] max-w-sm leading-relaxed text-sm">
            Massage panggilan profesional di Yogyakarta. Terapis bersertifikat,
            bebas uang transport, siap datang ke tempat Anda 24 jam.
          </p>
        </div>

        <div>
          <h4 className="uppercase text-xs tracking-[0.2em] text-[#b8862f] mb-5">
            Area Layanan
          </h4>
          <p className="text-[#e5d9c5] text-sm leading-relaxed mb-4">
            Melayani seluruh area Yogyakarta.
          </p>
          <ul className="flex flex-wrap gap-x-4 gap-y-2 text-sm">
            {AREAS.map((a) => (
              <li key={a.slug}>
                <Link
                  to={`/area/${a.slug}`}
                  data-testid={`footer-area-${a.slug}`}
                  className="text-[#e5d9c5] hover:text-white link-underline"
                >
                  {a.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="uppercase text-xs tracking-[0.2em] text-[#b8862f] mb-5">
            Kontak
          </h4>
          <ul className="space-y-4 text-sm text-[#e5d9c5]">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[#b8862f]" /> {WA_DISPLAY}
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 text-[#b8862f]" /> Buka 24 Jam
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 text-[#b8862f] mt-0.5" /> Seluruh area
              Yogyakarta
            </li>
          </ul>
          <a
            href={waLink("Halo Javanese Spa Jogja, saya ingin booking Massage panggilan.")}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-booking-btn"
            className="inline-block mt-6 rounded-full bg-[#b8862f] text-[#2c1e16] px-6 py-2.5 text-sm font-medium hover:bg-[#faf7f2] transition-colors"
          >
            Booking via WhatsApp
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 text-xs text-[#e5d9c5]/70 flex flex-col sm:flex-row justify-between gap-3">
        <span>© {new Date().getFullYear()} {BRAND}. Semua hak dilindungi.</span>
        <span>Massage Panggilan Profesional · Yogyakarta</span>
      </div>
    </div>
  </footer>
);
